class CONSTANTS {
  static isDev = false;
  static devRoute = 'http://localhost:5004';
  static pubRoute = 'https://tazeay.alemtilsimat.com/api';

  static get baseRoute() {
    return this.isDev ? this.devRoute : this.pubRoute;
  }
}

export default CONSTANTS;